// 🧾 Installateurs — Phase 3 : helpers des jours de fin de semaine admissibles (même règle d'avertissement que le backend).
export function estFinDeSemaine(dateIso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateIso || '')) return false;
  const [a, m, j] = dateIso.split('-').map(Number);
  const wd = new Date(a, m - 1, j).getDay();
  return wd === 0 || wd === 6;
}

export const avertissementDate = (dateIso) => (!dateIso || estFinDeSemaine(dateIso) ? '' : "Cette date n'est pas une fin de semaine (samedi ou dimanche)");

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const [a, m, j] = iso.split('-').map(Number);
  return new Intl.DateTimeFormat('fr-CA', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(a, m - 1, j));
};

export const fmtHorodatage = (iso) => (iso ? new Intl.DateTimeFormat('fr-CA', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(iso)) : '—');
